export function showDelayMinutes(delayMinutes) {
  const dms = delayMinutesStr(delayMinutes);
  if (dms === '60') {
    return '60分以上';
  }

  return `${dms}分`;
}

export function delayMinutesStr(delayMinutes) {
  if (isOver60Minutes(delayMinutes)) {
    return '60';
  }

  return `${delayMinutes}`;
}

function isOver60Minutes(delayMinutes) {
  if (delayMinutes >= 60) {
    return true;
  }

  return false;
}
